/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SortType {
  Asc = 'asc',
  Desc = 'desc'
}
